import { TICKETS } from '../game/economy';

const CARD_GRADIENTS = [
  'linear-gradient(160deg, #2b4bb0 0%, #0d1b3d 100%)',
  'linear-gradient(160deg, #7c3aed 0%, #2e1065 100%)',
  'linear-gradient(160deg, #0f8a7a 0%, #062f2a 100%)',
  'linear-gradient(160deg, #c2410c 0%, #431407 100%)',
];

export const cardGradient = (ticket: number): string => {
  const idx = TICKETS.indexOf(ticket);
  return CARD_GRADIENTS[(idx < 0 ? 0 : idx) % CARD_GRADIENTS.length];
};

const p2 = (n: number): string => String(n).padStart(2, '0');

/** With `dayUnit` (e.g. «д»), days split off once >=24h remain: `6д 23:59:59`;
 *  without it the legacy total-hours HH:MM:SS is kept. */
export const countdown = (endsAt: string, now: number, dayUnit?: string): string => {
  const diff = new Date(endsAt).getTime() - now;
  if (diff <= 0) return '00:00:00';
  const totalHours = Math.floor(diff / 3_600_000);
  const minutes = Math.floor((diff / 60_000) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  if (dayUnit && totalHours >= 24) {
    const days = Math.floor(totalHours / 24);
    return `${days}${dayUnit} ${p2(totalHours % 24)}:${p2(minutes)}:${p2(seconds)}`;
  }
  return `${p2(totalHours)}:${p2(minutes)}:${p2(seconds)}`;
};
